import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.globalWhite100};
    padding-bottom: 24px;
    border-bottom: 1px solid ${theme.colors.neutralGray10};

    .ant-tabs-top > .ant-tabs-nav::before,
    .ant-tabs-bottom > .ant-tabs-nav::before,
    .ant-tabs-top > div > .ant-tabs-nav::before,
    .ant-tabs-bottom > div > .ant-tabs-nav::before {
      border-bottom: 1px solid ${theme.colors.neutralSilver20};
    }

    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,
    .ant-tabs-tab {
      color: ${theme.colors.neutralSilver70};
    }

    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      text-shadow: none;
    }

    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,
    .ant-tabs-tab:hover {
      color: ${theme.colors.neutralSilver70};
    }

    .ant-tabs-ink-bar {
      background: ${theme.colors.brandPrimary70};
    }

    .ant-tabs-tab-btn {
      font-size: 1.6rem;
    }
  `}
`;

export const SignatureWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.neutralSilver5};
    width: 100%;
    border-radius: 4px;
    margin: 0 auto;

    position: relative;

    .signatureBoard {
      width: 100%;
      height: 168px;
    }

    &::after {
      content: '';
      width: calc(100% - 48px);
      height: 1px;
      position: absolute;
      top: 50%;
      left: 24px;
      background-color: black;
    }
  `}
`;

export const ClearButton = styled.button`
  ${({ theme }) => css`
    position: absolute;
    top: 16px;
    right: 16px;

    background: transparent;
    border: none;

    font-size: 1.4rem;
    font-weight: 500;
    color: ${theme.colors.neutralSilver50};

    cursor: pointer;

    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
  `}
`;

export const WrittenSignatureContainer = styled.div`
  height: 168px;
`;

export const Description = styled.div`
  margin-top: 16px;
`;
